<template>

    <AppTopBar>
        <template #actions>
            <Link
                v-if="siteUuid"
                :href="'/site/' + siteUuid"
                class="text-sm text-gray-600 hover:text-main px-3 py-1.5 rounded-lg hover:bg-bay inline-flex items-center gap-1"
            >
                <span class="material-symbols-outlined" style="font-size: 1rem">dashboard</span>
                Site overview
            </Link>
            <a
                v-if="liveSiteUrl"
                :href="liveSiteUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm bg-main text-white px-3 py-1.5 rounded-lg hover:opacity-90 inline-flex items-center gap-1"
            >
                <span class="material-symbols-outlined" style="font-size: 1rem">open_in_new</span>
                View live
            </a>
        </template>
    </AppTopBar>

    <div class="flex" style="
      height: auto;
      min-height: 100vh;
      background: white;
    ">
        <aside class="sidebar w-64 h-full flex flex-col sticky top-0 border-r border-gray-100">
            <div class="flex-1 bg-white w-full pt-3 overflow-y-auto">

                <SidebarLink href="/" label="All websites" icon="grid_view" :active="pathExact('/')" />

                <p class="px-6 text-xs font-semibold uppercase tracking-wide text-gray-400 mt-4 mb-1">Site</p>
                <SidebarLink
                    v-if="siteUuid"
                    :href="'/site/' + siteUuid"
                    label="Overview & thumbnails"
                    icon="dashboard"
                    :active="isSiteOverview(siteUuid)"
                />

                <p class="px-6 text-xs font-semibold uppercase tracking-wide text-gray-400 mt-4 mb-1">Pages</p>
                <p class="px-6 text-xs text-gray-400 mb-1">Drag the handle to reorder</p>
                <DraggableNavList
                    v-if="localPages.length && siteUuid"
                    :items="localPages"
                    :site-uuid="siteUuid"
                    :active-uuid="activePageUuid"
                    zone="pages"
                    :order-endpoint="'/site/' + siteUuid + '/update/page/order'"
                    @reorder="localPages = $event"
                />
                <p v-else class="px-6 text-sm text-gray-400">No pages yet</p>

                <p class="px-6 text-xs font-semibold uppercase tracking-wide text-gray-400 mt-4 mb-1">Portfolio</p>
                <SidebarLink
                    :href="'/site/' + siteUuid + '/create/portfolio'"
                    label="New portfolio item"
                    icon="add_circle"
                    :active="pathExact('/site/' + siteUuid + '/create/portfolio')"
                />
                <DraggableNavList
                    v-if="localPortfolio.length && siteUuid"
                    :items="localPortfolio"
                    :site-uuid="siteUuid"
                    :active-uuid="activePageUuid"
                    zone="portfolio"
                    removable
                    :order-endpoint="'/site/' + siteUuid + '/update/portfolio/order'"
                    @reorder="localPortfolio = $event"
                />
                <p v-else class="px-6 text-sm text-gray-400 pb-2">No portfolio items yet</p>

<template v-if="false">

                <div class="p-4 pb-0">
                    <h3 class="text-lg font-semibold">Not Linked</h3>
                </div>
                    <div class="flex flex-col mt-2">
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">Privacy</Link>
                    </div>                    
    
                <div class="p-4 pb-0">
                    <h3 class="text-lg font-semibold">Layout</h3>
                </div>
                    <div class="flex flex-col mt-2">
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">Menu</Link>
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">Footer</Link>
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">Socials</Link>
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">Contact</Link>
                    </div>

                <div class="p-4 pb-0">
                    <h3 class="text-lg font-semibold">Tools</h3>
                </div>
                    <div class="flex flex-col mt-2">
                        <Link class="p-2 pr-8 pl-8" href="/" :class="{ 'bg-bay': urlExact('/') }">SEO</Link>
                    </div>
</template>

            </div>
        </aside>
    
        <div class="bg-bay flex-1 pt-4">
    
            <div class="main-container bg-bay flex-1" style="
            overflow: auto;
            overflow-x: hidden;
            height: 100%;
            ">
    
                <div
                    class="bg-white m-4 min-h-full overflow-auto relative"
                    :class="padded ? 'mt-4 p-8 rounded-xl' : 'mt-0'"
                    style="overflow-x: hidden;"
                >
                    <slot />
                </div>
    
            </div>
    
        </div>
    
    </div>
    <template v-if="this.adminStatus"> 
    <div class="bg-black bg-opacity-20 fixed top-0 left-0 w-full h-full">
        <div class="w-1/2 fixed bg-bay p-4 rounded-2xl overflow-auto" style="left: 4%; height: 90%; top: 5%; width: calc(45%); padding-right: 5%;">
            <button class="mt-2 mb-6 w-fit pr-3 pl-3 rounded-xl p-2 font-semibold w-full transition cursor-pointer flex items-center justify-center bg-main text-white" @click="adminShow(false)">
                <span class="material-symbols-outlined" style="font-size: 1.3rem;">arrow_back_ios</span> 
                Go back to Task
            </button>
    
            <div class="flex flex-wrap gap-2">
                <button class="w-32 h-32 rounded-xl relative" 
                :class="{ 
                    'bg-main text-white': admin_docker === 'roles', 
                    'bg-white text-black': admin_docker !== 'roles' 
                }"
                @click="changeDocker('roles', 'roles')"><span>Roles</span></button>
                <button class="w-32 h-32 rounded-xl relative"
                :class="{ 
                    'bg-main text-white': admin_docker === 'employees', 
                    'bg-white text-black': admin_docker !== 'employees' 
                }"
                @click="changeDocker('employees', 'employees')"><span>Employees</span></button>
                <button class="w-32 h-32 rounded-xl relative"
                :class="{ 
                    'bg-main text-white': admin_docker === 'settings', 
                    'bg-white text-black': admin_docker !== 'settings' 
                }"
                @click="changeDocker('settings', 'settings')"><span>Features</span></button>
                <button class="w-32 h-32 rounded-xl relative"
                :class="{ 
                    'bg-main text-white': admin_docker === 'Billing', 
                    'bg-white text-black': admin_docker !== 'Billing' 
                }"
                @click="changeDocker('Billing', 'Billing')"><span>Billing</span></button>
            </div>
    
        </div>
        <div class="w-1/2 fixed bg-bay p-4 rounded-2xl overflow-auto" style="left: 51%; height: 90%; top: 5%; width: calc(45%);" v-if="admin_docker === 'roles'">
            <template v-if="this.admin_page === 'roles'">
                <div class="flex justify-between mb-2 items-center">
                    <h3 class="text-lg font-semibold mb-2 block">Company Role</h3>
                    <button class="bg-primary p-3 pl-8 pr-8 pb-3 rounded-xl w-fit text-medium h-fit text-white" @click="openCreateRole()">Create Role</button>
                </div>
                <div class="flex flex-col gap-2">
                    <template v-for="role in this.admin_roles">
                    <div class="bg-white p-4 flex justify-between rounded-lg">
                        <h4 class="font-semibold">{{ role.name }}</h4><button @click="editRole(role.uuid)">Edit</button>
                    </div>
                    </template>
                </div>
            </template>
            <template v-else-if="this.admin_page === 'editRole'">
                <div class="flex justify-between">
                    <h3 class="text-lg font-semibold mb-2 block">Company Roles</h3>
                </div>
    
                <div class="flex flex-col gap-2">
                    
                    <div class="bg-white p-4 flex justify-between rounded-lg">
                        <button @click="this.admin_page = 'roles'" class="flex items-center"><span class="material-symbols-outlined" style="font-size: 1.3rem;">arrow_back_ios</span> Go back to Roles</button><h4 class="font-semibold"></h4>
                    </div>
    
                    <template v-if="admin_selectedRole">
                    
                    <label class="mt-2">Role Name</label>
                    <input v-model="admin_selectedRole.name" class="bg-white p-4 flex justify-between rounded-lg" />
                
    
                    <template v-show="false">
                        <label class="mt-2">Role Description</label>
                        <textarea class="bg-white p-4 flex justify-between rounded-lg"> </textarea>
                    </template>
                    <label class="mt-4">Privileges</label>
                    <div class="grid grid-cols-3 gap-4">
                        <template v-for="privilege in this.admin_privilege">
                        <div class="flex gap-1">
                            <input type="checkbox" :checked="getChecked(privilege.id)" :id="privilege.id" :name="privilege.id" :value="privilege.id" @click="addToPrivileges(privilege.id)"><label :for="privilege.id" style="line-height: 14px;">{{ privilege.name }}</label>
                        </div>
                        </template>
                    </div>
    
    
                    </template>
                    
                </div>
    
                <div class="flex justify-between mt-8">
                <div class="flex gap-4">
                    <button @click="selectAll()" class="bg-secondary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white" v-if="this.selected">Select all</button>
                    <button @click="selectAll()" class="bg-secondary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white" v-else>Unselect all</button>
                    <button @click="restoreAll()" class="bg-white p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-black" >Restore all</button>
                </div>
    
                <button @click="saveRole()" class="bg-primary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white">Save Role</button>
                </div>
    
    
    
            </template>
            <template v-else-if="this.admin_page === 'role_create'">
                <div class="flex justify-between">
                    <h3 class="text-lg font-semibold mb-2 block">Company Roles</h3>
                </div>
    
                <div class="flex flex-col gap-2">
                    
                    <div class="bg-white p-4 flex justify-between rounded-lg">
                        <button @click="this.admin_page = 'roles'" class="flex items-center"><span class="material-symbols-outlined" style="font-size: 1.3rem;">arrow_back_ios</span> Go back to Roles</button><h4 class="font-semibold"></h4>
                    </div>
    
    
                    
                    <label class="mt-2">Role Name</label>
                    <input v-model="admin_selectedRole.name" class="bg-white p-4 flex justify-between rounded-lg" />
                
    
                    <template v-show="false">
                        <label class="mt-2">Role Description</label>
                        <textarea class="bg-white p-4 flex justify-between rounded-lg"> </textarea>
                    </template>
                    <label class="mt-4">Privileges</label>
                    <div class="grid grid-cols-3 gap-4">
                        <template v-for="privilege in this.admin_privilege">
                        <div class="flex gap-1">
                            <input type="checkbox" :checked="getChecked(privilege.id)" :id="privilege.id" :name="privilege.id" :value="privilege.id" @click="addToPrivileges(privilege.id)"><label :for="privilege.id" style="line-height: 14px;">{{ privilege.name }}</label>
                        </div>
                        </template>
                    </div>
    
    
            
                    
                </div>
    
                <div class="flex justify-between mt-8">
                <div class="flex gap-4">
                    <button @click="selectAll()" class="bg-secondary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white" v-if="this.selected">Select all</button>
                    <button @click="selectAll()" class="bg-secondary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white" v-else>Unselect all</button>
                </div>
    
                <button @click="createRole()" class="bg-primary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white">Create Role</button>
                </div>
    
    
    
            </template>    
        </div>
        <div class="w-1/2 fixed bg-bay p-4 rounded-2xl overflow-auto" style="left: 51%; height: 90%; top: 5%; width: calc(45%);" v-if="admin_docker === 'employees'">
            <template v-if="admin_page === 'employees'">
                <div class="flex justify-between mb-2 items-center">
                    <h3 class="text-lg font-semibold mb-2 block">Employees</h3>
                    <button class="bg-primary p-3 pl-8 pr-8 pb-3 rounded-xl w-fit text-medium h-fit text-white" @click="openCreateEmployee()">Create Employee</button>
                </div>
                <div class="flex flex-col gap-2">
                    <template v-for="employee in this.admin_employees">
                    <div class="bg-white p-4 flex rounded-lg">
                        <h4 class="font-semibold">{{ employee.first_name }} {{ employee.last_name }}</h4>
                        <label v-if="false" v-for="role in employee.roles" class="ml-4">
                            <span v-if="this.getRole(role.uuid) !== null">{{ this.getRole(role.uuid).name }}</span>
                        </label><div class="flex-1"></div>
                        <button @click="openEditEmployee(employee.account_id)">Edit</button>
                    </div>
                    </template>
                </div>
            </template>
            <template v-if="admin_page === 'edit_employee'">
            
                <div class="flex justify-between">
                    <h3 class="text-lg font-semibold mb-2 block">Employees</h3>
                </div>
    
                <div class="flex flex-col gap-2">
                    
                    <div class="bg-white p-4 flex justify-between rounded-lg">
                        <button @click="this.admin_page = 'employees'" class="flex items-center"><span class="material-symbols-outlined" style="font-size: 1.3rem;">arrow_back_ios</span> Go back to Employees</button><h4 class="font-semibold"></h4>
                    </div>
    
                    <template v-if="admin_selected_employee">
                    
                    <div class="flex gap-4">
                        <div class="w-1/2">    
                            <label class="mt-2 mb-2 block">First Name</label>
                            <input disabled v-model="admin_selected_employee.first_name" class="bg-white p-4 flex opacity-70 cursor-not-allowed justify-between rounded-lg w-full" />
                        </div>
                        <div class="w-1/2">
                            <label class="mt-2 mb-2 block">First Name</label>
                            <input disabled v-model="admin_selected_employee.last_name" class="bg-white p-4 flex opacity-70 cursor-not-allowed justify-between rounded-lg w-full" />
                        </div>
                    </div>
                
    
                        <label class="mt-2">Email</label>
                        <input disabled v-model="admin_selected_employee.email" class="bg-white p-4 flex opacity-70 cursor-not-allowed justify-between rounded-lg" /> 
                   
    
                    <label class="mt-4">Roles</label>
                    <div class="grid grid-cols-1 gap-4">
    
                        <template v-for="role in this.admin_roles">
                        <div class="flex gap-1">
                            <input type="checkbox" :checked="getRoleChecked(role.uuid)" :id="role.uuid" :name="role.uuid" :value="role.uuid" @click="addToEmployeeRoles(role.uuid)"><label :for="role.uuid" style="line-height: 14px;">{{ role.name }}</label>
                        </div>
                        </template>
                    </div>
    
    
                    </template>
                    
                </div>
    
                <div class="flex justify-between mt-8">
                <button @click="disableEmployee()" class="bg-main p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white">Disable Employee</button>
                <button @click="createEmployee()" class="bg-primary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white">Save Employee</button>
                </div>
            
            </template>
            <template v-if="admin_page === 'create_employee'">
            
                <div class="flex justify-between">
                    <h3 class="text-lg font-semibold mb-2 block">Employees</h3>
                </div>
    
                <div class="flex flex-col gap-2">
                    
                    <div class="bg-white p-4 flex justify-between rounded-lg">
                        <button @click="changeDocker('employees', 'employees')" class="flex items-center"><span class="material-symbols-outlined" style="font-size: 1.3rem;">arrow_back_ios</span> Go back to Employees</button><h4 class="font-semibold"></h4>
                    </div>
    
                    <template v-if="true">
                    
                    <div class="flex gap-4">
                        <div class="w-1/2">    
                            <label class="mt-2 mb-2 block">First Name</label>
                            <input v-model="admin_selected_employee.first_name" placeholder="John" class="bg-white p-4 flex justify-between rounded-lg w-full" />
                        </div>
                        <div class="w-1/2">
                            <label class="mt-2 mb-2 block">First Name</label>
                            <input v-model="admin_selected_employee.last_name" placeholder="Doe" class="bg-white p-4 flex justify-between rounded-lg w-full" />
                        </div>
                    </div>
                
    
                        <label class="mt-2">Email</label>
                        <input v-model="admin_selected_employee.email" placeholder="j.doe@example.com" class="bg-white p-4 flex justify-between rounded-lg" /> 
                   
    
                    <label class="mt-4">Roles</label>
                    <div class="grid grid-cols-1 gap-4">
    
                        <template v-for="role in this.admin_roles">
                        <div class="flex gap-1">
                            <input type="checkbox" :checked="getRoleChecked(role.uuid)" :id="role.uuid" :name="role.uuid" :value="role.uuid" @click="addToEmployeeRoles(role.uuid)"><label :for="role.uuid" style="line-height: 14px;">{{ role.name }}</label>
                        </div>
                        </template>
                    </div>
    
    
                    </template>
                    
                </div>
    
                <div class="flex justify-between mt-8">
                <div class="flex gap-4">
    
                </div>
    
                <button @click="createEmployee()" class="bg-primary p-2 pl-8 pr-8 pb-3 rounded-full w-fit text-medium h-fit text-white">Invite Employee</button>
                </div>        
            
            </template>
        </div>
    </div>
    
    
    
    </template><template v-else />
    </template>
          
    <script>
    import { Link, usePage } from '@inertiajs/vue3';
    import axios from 'axios'
    import AppTopBar from '@/Shared/layout/AppTopBar'
    import SidebarLink from '@/Shared/layout/SidebarLink'
    import DraggableNavList from '@/Shared/layout/DraggableNavList'
    import {
        pathExact,
        isSiteOverviewPath,
    } from '@/Shared/layout/navPath'
    import { queueScreenshotCaptures } from '@/Shared/screenshotQueue'

    export default {

        props: {
            title: String,
            description: String,
            subtitle: String,
            type: String,
            pages: Object,
            page_uuid: String,
            portfolio: Object,
            site_uuid: String,
            domain: String,
            page: Object,
            padded: {
                type: Boolean,
                default: false,
            },
        },
        components: {
          Link,
          AppTopBar,
          SidebarLink,
          DraggableNavList,
        },
        watch: {
            pageList: {
                immediate: true,
                handler(pages) {
                    this.localPages = Array.isArray(pages) ? [...pages] : []
                },
            },
            portfolioList: {
                immediate: true,
                handler(portfolio) {
                    this.localPortfolio = Array.isArray(portfolio) ? [...portfolio] : []
                },
            },
        },
        computed: {
            inertiaProps() {
                return usePage().props
            },
            siteUuid() {
                const sites = this.inertiaProps.sites
                return this.site_uuid || this.inertiaProps.site_uuid || (sites && sites.uuid) || null
            },
            activePageUuid() {
                return this.page_uuid || this.inertiaProps.page_uuid || null
            },
            pageList() {
                const pages = this.pages ?? this.inertiaProps.pages
                return Array.isArray(pages) ? pages : []
            },
            portfolioList() {
                const portfolio = this.portfolio ?? this.inertiaProps.portfolio
                return Array.isArray(portfolio) ? portfolio : []
            },
            siteDomain() {
                const domain = this.domain || this.inertiaProps.domain
                if (domain) return domain.replace(/^https?:\/\//, '')
                const sites = this.inertiaProps.sites
                if (sites && sites.domain) return sites.domain
                return ''
            },
            liveSiteUrl() {
                if (!this.siteDomain) return null
                const base = `https://${this.siteDomain}`
                if (!this.activePageUuid) return base
                const all = [...this.pageList, ...this.portfolioList]
                const match = all.find(p => p.uuid === this.activePageUuid)
                if (match?.path) return `${base}${match.path}`
                return base
            },
        },
        data() {
            return {
                adminStatus: false,
                admin_roles: [],
                admin_docker: "roles",
                admin_page: "roles",
                admin_selectedRole: null,
                admin_privilege: [],
                admin_privilege_checked: [],
                selected: true,
                restore: null,
                admin_employees: [],
                admin_employee_roles: [],

                localPages: [],
                localPortfolio: [],
            }
        },
        mounted() {
            queueScreenshotCaptures(usePage().props.pending_capture_urls)
        },
        methods: {
            async changeDocker(docker, page){
                this.admin_docker = docker
                this.admin_page = page
    
                if(docker === 'employees') {
    
                    const response = await axios.post('/admin/get/employees', {})
    
                    this.admin_employee_roles = response.data.roles
                    this.admin_employees = response.data.employees
    
                }
    
            },
    
            async openEditEmployee(uuid) {
                try {
    
                    const response = await axios.post('/admin/get/employee/'+uuid, {})
    
                    this.admin_page = "edit_employee"
                    this.admin_selected_employee = response.data.employee
                    this.admin_company_roles = response.data.roles
                    this.admin_company_roles_selected = response.data.employee.roles
                    this.admin_employee_roles = response.data.employee.roles
    
                  //  if(this.admin_employee_roles === undefined) { this.admin_employee_roles = [] }
                 
                } catch (error) {
                    console.error(error)
                }
            },  
      
    
            async openCreateEmployee() {
                try {
    
                    const response = await axios.post('/admin/get/create/employee', {})
    
                    this.admin_page = "create_employee"
                    this.admin_selected_employee = []
                    this.admin_company_roles = response.data.roles
                    this.admin_company_roles_selected = []
                    this.admin_employee_roles = []
                 
                } catch (error) {
                    console.error(error)
                }
            },  
            async createEmployee() {
                try {
    
                    const employee = this.admin_selected_employee;
                    const response = await axios.post('/admin/create/employee', {"email":employee.email,"first_name":employee.first_name,"last_name":employee.last_name,"checked_roles":this.admin_employee_roles})
    
                    const data = response.data.employee
    
                   // this.admin_employees.push(data)
    
                    this.admin_page = "employees"
                    // this.admin_selectedRole = null
                    // this.admin_privilege = []
                    // this.admin_privilege_checked = []
    
                    if(response.data.user_is_user === true) {
                        window.location.reload()
                    }
    
                } catch (error) {
                    console.error(error)
                }
            },  
            async openCreateRole() {
                try {
    
                    const response = await axios.post('/admin/create/role/preview', {})
    
                    this.admin_page = "role_create"
                    this.admin_privilege = response.data.Privilege
                    this.admin_privilege_checked = []
                    this.admin_selectedRole = []
                 
                } catch (error) {
                    console.error(error)
                }
            },  
            async createRole() {
                try {
    
                    const response = await axios.post('/admin/create/role', {"name":this.admin_selectedRole.name,"privilege":this.admin_privilege_checked})
    
                    const data = response.data.role
    
                    this.admin_roles.push(data)
    
                    this.admin_page = "roles"
                    this.admin_selectedRole = null
                    this.admin_privilege = []
                    this.admin_privilege_checked = []
                 
                } catch (error) {
                    console.error(error)
                }
            },  
            restoreAll() {
                this.admin_privilege_checked = this.restore 
                this.checkIfSelectedAll()
            },
            getItemById(id) {
                return this.admin_roles.find(role => role.uuid === id) || null;
            },
            selectAll() {
                var allUuids = []; // Initialize the array
                this.admin_privilege.forEach(privilege => {
                 
                    allUuids.push(privilege.id);
                });
    
                if(allUuids.length === this.admin_privilege_checked.length) {
                    this.admin_privilege_checked = []  
                } else {
                    this.admin_privilege_checked = allUuids;
                }
    
                this.checkIfSelectedAll()
    
            },
            checkIfSelectedAll() {
    
                var allUuids = []; // Initialize the array
                this.admin_privilege.forEach(privilege => {
                 
                    allUuids.push(privilege.id);
                });
    
               
    
                if(allUuids.length === this.admin_privilege_checked.length) { this.selected = false } else { this.selected = true }
    
            },        
            getChecked(uuid) {
                const isUuidInArray = this.admin_privilege_checked.includes(uuid)
                return isUuidInArray
            },
            getRoleChecked(uuid) {
    
                return this.admin_employee_roles.some(item => item.uuid === uuid);
    
           
            },
            getRole(uuid) {
                return this.admin_employee_roles.find(role => role.uuid === uuid) || null;
            },
            async editRole(uuid) {
                try {
                    const response = await axios.post('/admin/get/role/'+uuid, {})
                    this.admin_page = "editRole"
                    this.admin_selectedRole = response.data.Role
                    this.admin_privilege = response.data.Privilege
                    this.admin_privilege_checked = response.data.privileges
                    this.restore = response.data.privileges
                } catch (error) {
                    console.error(error)
                }
            },
            addToPrivileges(uuid) {
                const index = this.admin_privilege_checked.indexOf(uuid);
                if (index !== -1) {
                // If found, remove the UUID
                this.admin_privilege_checked.splice(index, 1);
                } else {
                // If not found, add the UUID
                this.admin_privilege_checked.push(uuid);
                }
    
                this.checkIfSelectedAll()
            },
            addToEmployeeRoles(uuid) {
                const index = this.admin_employee_roles.findIndex(role => role.uuid === uuid);
                if (index !== -1) {
                    // If found, remove the UUID
                    this.admin_employee_roles.splice(index, 1);
                } else {
                    // If not found, add the UUID
                    this.admin_employee_roles.push({ uuid: uuid });
                }
            },
            async saveRole() {
                try {
    
                    
                    const response = await axios.post('/admin/set/role/'+ this.admin_selectedRole.uuid, {"name":this.admin_selectedRole.name,"privilege":this.admin_privilege_checked})
    
                    this.getItemById(this.admin_selectedRole.uuid).name = this.admin_selectedRole.name
                    this.admin_page = "roles"
                    this.admin_selectedRole = null
                    this.admin_privilege = []
                    this.admin_privilege_checked = []
                    
                    if(response.data.user_has_role === true) {
                        window.location.reload();
                    }
    
                } catch (error) {
                    console.error(error)
                }
            },        
            pathExact,
            isSiteOverview(siteUuid) {
                return isSiteOverviewPath(siteUuid)
            },
            urlContains(segment) {
            return window.location.href.includes(segment);
            }, 
            urlExact(segment) {
                return pathExact(segment);
            },
            adminShow(status) {
                if(status === true) {
                    this.adminStatus = true 
                    this.getRoles()
                } else {
                    this.adminStatus = false 
                }
            },
            async getRoles() {
                try {
                    const response = await axios.post('/admin/get/roles', this.task)
                    this.admin_roles = response.data.Roles
                  
     
    
                } catch (error) {
                    console.error(error)
                }
            },

        }
    }
    </script>